define('fukit/behavior/authorization.behavior',['require','exports','module','underscore','marionette','backbone.radio','../helpers/roles.helper','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _           = require('underscore'),
      Mn          = require('marionette'),
      Radio       = require('backbone.radio'),
      RolesHelper = require('../helpers/roles.helper'),
      UIKit       = require('uikit/uikit');

  var AuthorizationBehavior = Mn.Behavior.extend({
    defaults: {
      enableOnlyWhen: null,
      visibleOnlyWhen: null,
      setTextWhen: null,
    },

    authorizationStates: {},

    modelEvents: {
      sync: 'updateViewOnModelSync',
    },

    events: {
      click: 'sendNotificationOnClick',
    },

    updateViewOnModelSync: function() {
      var state = Radio.request('AppKit.controllerService', 'state');

      if (!this.view.model.isNew()) {
        state.set({ authorizationMode: null });
      }

      this.setViewAuthorizations();
    },

    sendNotificationOnClick: function(ev) {
      var authorizationState = this.getAuthorizationStateForView(this.view);

      if (authorizationState && !this.view.isAllowed && authorizationState.message) {
        ev.stopPropagation();
        ev.preventDefault();
        this.sendNotification(authorizationState.message);
      }
    },

    onFirstBeforeRender: function() {
      this.setViewAuthorizations();
    },

    setViewAuthorizations: function() {
      //prettier-ignore
      var enableOnlyWhenOptions  = this.getOption('enableOnlyWhen'),
          visibleOnlyWhenOptions = this.getOption('visibleOnlyWhen'),
          setTextWhenOptions     = this.getOption('setTextWhen');

      if (enableOnlyWhenOptions) {
        this.applyEnableOnlyWhenOptions(enableOnlyWhenOptions);
      }
      if (visibleOnlyWhenOptions) {
        this.applyVisibleOnlyWhenOptions(visibleOnlyWhenOptions);
      }
      if (setTextWhenOptions) {
        this.applySetTextWhenOptions(setTextWhenOptions);
      }
    },

    applyEnableOnlyWhenOptions: function(options) {
      var option = RolesHelper.getMatchedOption(options, this);

      this.initializeAuthorizationViewState(option);
      if (option && !this.view.isAllowed) {
        // if disableOnly option is set, don't apply disallowed class that enables
        // the pointer events and applies disallowed pointer
        if (!_.has(option, 'disableOnly')) {
          this.view.$el.addClass('disallowed');
        }
        this.view.disabled = true;
        this.view.stopPropagation = true;
        UIKit.freezeOption(this.view, 'disabled');
      }
    },

    applyVisibleOnlyWhenOptions: function(options) {
      var option = RolesHelper.getMatchedOption(options, this);

      this.initializeAuthorizationViewState(option);
      if (option && !this.view.isAllowed) {
        this.view.visible = false;
        if (_.has(option, 'message')) {
          this.sendNotification(option.message);
        }
        UIKit.freezeOption(this.view, 'visible');
      }
    },

    applySetTextWhenOptions: function(options) {
      var option = RolesHelper.getMatchedOption(options, this);

      this.initializeAuthorizationViewState(option);
      if (option && !this.view.isAllowed) {
        this.view.text = option.text;
        UIKit.freezeOption(this.view, 'text');
      }
    },

    initializeAuthorizationViewState: function(option) {
      if (option) {
        if (_.isFunction(option.isAllowed)) {
          this.view.isAllowed = option.isAllowed.call(this);
        } else {
          this.view.isAllowed = RolesHelper.evaluateRolesOptions(option.roles);
        }
        if (option && !this.view.isAllowed) {
          this.setAuthorizationStateForView(this.view, option);
        }
      }
    },

    setAuthorizationStateForView: function(view, option) {
      this.authorizationStates[view.cid] = option;
    },

    getAuthorizationStateForView: function(view) {
      return this.authorizationStates[view.cid];
    },

    sendNotification: function(message) {
      Radio.request('notificationService', 'showNotification', message);
    },
  });

  module.exports = AuthorizationBehavior;
});

